<template>
	<div>
		<action-sidebar :title="title" :value="true" @close-modal="closeModal">
			<v-layout wrap pa-5>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Tarea" type="number"
						v-model="$v.model.taskOrder.$model" :error="$v.model.taskOrder.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-textarea
						background-color="white"
						box
						class="body-1"
						height="80"
						hide-details
						label="Descripción"
						no-resize
						v-model="$v.model.description.$model" :error="$v.model.description.$error"
					>
					</v-textarea>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Uri Web"
						v-model="$v.model.uriWeb.$model" :error="$v.model.uriWeb.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Uri Movil"
						v-model="$v.model.uriMobile.$model" :error="$v.model.uriMobile.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-select background-color="white" class="body-1 mt-2" box hide-details item-text="code"
					item-value="code" label="Metodo" :items="methods" v-model="$v.model.method.$model"
					:error="$v.model.method.$error"></v-select>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Codigo"
						v-model="$v.model.code.$model" :error="$v.model.code.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Module"
						v-model="$v.model.module.$model" :error="$v.model.module.$error">
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Icono"
						v-model="model.icon" >
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field background-color="white" box class="body-1" hide-details label="Color"
						v-model="model.color">
					</v-text-field>
				</v-flex>
			
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button :is-loading="$v.$invalid || loading" @accept-button-clicked="saveService"
					@cancel-button-clicked="closeModal">
				</modal-sidebar-button>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import { required } from 'vuelidate/lib/validators';

function closeModal() {
	this.goTo('page-tasks-level');
}

async function saveService() {
	const method = this.taskId ? 'patch' : 'post';
	const url = this.taskId ? `task/${this.taskId}` : 'task';
	const message = this.taskId ? 'modificó' : 'creó';
	try {
		this.model.levelId = this.id;
		await this.$http[method](url, this.model, { headers: this.headers });
		this.showNotification(`Se ${message} la tarea correctamente`);
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function title() {
	const action = 'Tarea';
	return this.taskId ? `Editar ${action}` : `Nuevo ${action}`;
}

async function loadData() {
	const requests = [this.$http.get(`project/${this.codeProject}/items`), this.$http.get('type-plans', { headers: this.headers })];
	if (this.taskId) {
		requests.push(this.$http.get(`task/${this.taskId}`, { headers: this.headers }));
	}
	try {
		const responses = await Promise.all(requests);
		[{ data: { data: this.items } }, { data: { data: this.typePlans } }] = responses;
		if (this.taskId) {
			[, , { data: this.model }] = responses;
			this.model = this.model.data;
			this.model.codeProject = this.codeProject;
		}
	} catch (error) {
		this.showError();
	}
}

function created() {
	this.loadData();
}

function validations() {
	const validation = {
		model: {
			taskOrder: {
				required,
			},
			description: {
				required,
			},
			uriWeb: {
				required,
			},
			uriMobile: {
				required,
			},
			method: {
				required,
			},
			module: {
				required,
			},
			code: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		domains: [],
		headers: { Accept: `${process.env.ACCEPT_SERVICE_V2}` },
		methods: [
			{ code: 'GET', name: 'GET' },
			{ code: 'POST', name: 'POST' },
			{ code: 'PATCH', name: 'PATCH' },
			{ code: 'PUT', name: 'PUT' },
			{ code: 'DELETE', name: 'DELETE' },
		],
		platforms: [
			{ code: 1, name: 'Web' },
			{ code: 2, name: 'Movil' },
			{ code: 3, name: 'Movil/Web' },
		],
		loading: false,
		model: {
			taskOrder: null,
			description: null,
			uriWeb: null,
			uriMobile: null,
			method: null,
			code: null,
			module: null,
			color: null,
			icon: null,
		},
	};
}

export default {
	name: 'page-new-levels',
	data,
	components: {
		actionSidebar,
	},
	created,
	computed: {
		title,
	},
	methods: {
		closeModal,
		loadData,
		saveService,
	},
	props: {
		taskId: {
			type: [Number, String],
		},
		id: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/pages/task/page-new-task.vue